var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialProfiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99945 4.55994C6.96152 4.55994 5.30945 6.21201 5.30945 8.24994C5.30945 10.2879 6.96152 11.9399 8.99945 11.9399C11.0374 11.9399 12.6895 10.2879 12.6895 8.24994C12.6895 6.21201 11.0374 4.55994 8.99945 4.55994ZM3.68945 8.24994C3.68945 5.31731 6.06682 2.93994 8.99945 2.93994C11.9321 2.93994 14.3095 5.31731 14.3095 8.24994C14.3095 11.1826 11.9321 13.5599 8.99945 13.5599C6.06682 13.5599 3.68945 11.1826 3.68945 8.24994Z",
    fill: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99945 13.5599C5.30467 13.5599 2.30945 16.5552 2.30945 20.2499C2.30945 20.6973 1.9468 21.0599 1.49945 21.0599C1.0521 21.0599 0.689453 20.6973 0.689453 20.2499C0.689453 15.6605 4.40997 11.9399 8.99945 11.9399C13.5889 11.9399 17.3095 15.6605 17.3095 20.2499C17.3095 20.6973 16.9468 21.0599 16.4995 21.0599C16.0521 21.0599 15.6895 20.6973 15.6895 20.2499C15.6895 16.5552 12.6942 13.5599 8.99945 13.5599Z",
    fill: "#808080"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1895 3.74994C14.1895 3.30259 14.5521 2.93994 14.9995 2.93994C17.9321 2.93994 20.3095 5.31731 20.3095 8.24994C20.3095 11.1826 17.9321 13.5599 14.9995 13.5599C14.5521 13.5599 14.1895 13.1973 14.1895 12.7499C14.1895 12.3026 14.5521 11.9399 14.9995 11.9399C17.0374 11.9399 18.6895 10.2879 18.6895 8.24994C18.6895 6.21201 17.0374 4.55994 14.9995 4.55994C14.5521 4.55994 14.1895 4.19729 14.1895 3.74994Z",
    fill: "#808080"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1895 12.7499C14.1895 12.3026 14.5521 11.9399 14.9995 11.9399C19.5889 11.9399 23.3095 15.6605 23.3095 20.2499C23.3095 20.6973 22.9468 21.0599 22.4995 21.0599C22.0521 21.0599 21.6895 20.6973 21.6895 20.2499C21.6895 16.5552 18.6942 13.5599 14.9995 13.5599C14.5521 13.5599 14.1895 13.1973 14.1895 12.7499Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialProfiles);
export default __webpack_public_path__ + "static/media/social-profiles.8caac2c822ee39fa23075cf6ee7897f4.svg";
export { ForwardRef as ReactComponent };